// extracted by css-extract-rspack-plugin
export default {"root":"neP3Gq","heading-and-subheading-block":"Wz_cJQ","headingAndSubheadingBlock":"Wz_cJQ","subheading":"DZpiyF"};